import { isNil } from "../Helper";
import DropDown from "./DropDown";
export default class DropDownGroup {
    constructor(_root) {
        this.root = _root;
        this.initialize();
    }
    initialize() {
        if (isNil(this.root)) {
            return;
        }
        const dropDownElements = Array.from(this.root.querySelectorAll(".neos-dropdown-trigger"));
        dropDownElements.forEach((_element) => {
            new DropDown(this.root, _element, true);
        });
    }
}
